import React, { ReactNode } from "react";

/** 異常Fallback頁面 */
export default class ErrorBoundary extends React.Component<{
  children: ReactNode;
}> {
  state: {
    error?: Error;
  };
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.


    return { error };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    // logErrorToMyService(error, errorInfo);

    // 砍Cache
    caches.keys().then((keyList) =>
      Promise.all(
        keyList.map((key) => {
          return caches.delete(key);
        }),
      ),
    )

    // 砍Service worker
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready
        .then((registration) => {
          registration.unregister();
        })
        .catch((error) => {
          console.error(error.message);
        });
    }
  }

  render() {
    if (this.state.error) {

      // 因網路不穩或網站更新導致區塊讀取失敗時
      if (this.state.error.name === 'ChunkLoadError') {
        return (
          <div className="flex flex-direction:column align-items:center justify-content:center height:100% p:0|16"
          >
            <div className="flex flex-direction:col align-items:center  b:1px|#dcdcdc|solid border-radius:8px p:64|48">
              <h2 className="font-size:96pt material-icons">warning</h2>
              <br />
              <p>網路不穩定或網站已有新版, 請重新整理.</p>
              <p>Network is unstable or website has been updated, please refresh the page.</p>
              <br />
              <div className="x-button primary">
                <a href="/?reload=1" className="flex flex-direction:row align-items:center gap:8 color:#FFFFFF"><i className='material-icons'>refresh</i> 重新載入 (Refresh)</a>
              </div>
              <br />
              <div className="x-divider mt:24 mb:24"></div>
              <div className="flex flex-direction:col gap:8">
                <div className="flex flex-direction:row gap:8 jc:center">
                  <span className="color:gray">Error: </span>
                  <span className="color:gray">ChunkLoadError</span>
                </div>
                <span className="text:center color:gray">
                  發生時間：{new Date().toLocaleDateString()}
                  {new Date().toTimeString()}
                </span>
              </div>
              <div className="x-divider mt:24 mb:24"></div>
              <span>
                問題持續發生?
                <a href="mailto:utfgtw@gmail.com"> 回報錯誤</a>
              </span>
            </div>
          </div>
        );
      }
      if (this.state.error.message === '初始化中發生錯誤！') {
        return (
          <div className="flex flex-direction:column align-items:center justify-content:center height:100% p:0|16">
            <div className="flex flex-direction:col align-items:center  b:1px|#dcdcdc|solid border-radius:8px p:64|48@>xs p:32|16@<=xs">
              <h2 className="font-size:96pt material-icons">warning</h2>
              <br />
              <p className="text:center">網路不穩定或系統正在維護, 請稍後再試.</p>
              <p className="text:center">The network is unstable or the system is under maintenance, please try again later.</p>
              <br />
              <div className="x-button primary">
                <a href="/?reload=1" className="flex flex-direction:row align-items:center gap:8 color:#FFFFFF"><i className='material-icons'>refresh</i> 重新載入 (Refresh)</a>
              </div>
              <br />
              <div className="x-divider mt:24 mb:24"></div>
              <div className="flex flex-direction:col gap:8">
                <div className="flex flex-direction:row gap:8 jc:center">
                  <span className="color:gray">Error: </span>
                  <span className="color:gray">ConfigServiceError</span>
                </div>
                <span className="text:center color:gray">
                  發生時間：{new Date().toLocaleDateString()}{' '}{new Date().toTimeString()}
                </span>
              </div>
              <div className="x-divider mt:24 mb:24"></div>
              <span>
                問題持續發生?  <a href="mailto:utfgtw@gmail.com">回報錯誤</a>
              </span>
            </div>

            {/*<RegistrationStatus />*/}
          </div>
        );
      }
      // You can render any custom fallback UI
      console.log(this.state.error);
      return (
        <div className="flex flex-direction:column align-items:center justify-content:center height:100%"
        >
          <div className="flex flex-direction:col align-items:center  b:1px|#dcdcdc|solid border-radius:8px p:64|48">
            <h2 className="font-size:96pt material-icons">warning</h2>
            <br />
            <p>很抱歉，發生不明錯誤</p>
            <p>Unexpected error occurred, please refresh the page.</p>
            <br />
            <br />
            <div className="x-button">
              <a href="/?reload=1" className="flex flex-direction:row align-items:center gap:8"><i className='material-icons'>refresh</i> 重新載入 (Refresh)</a>
            </div>
            <br />
            <div className="x-divider mt:8 mb:24"></div>
            <span>
              問題持續發生?
              <a href="mailto:utfgtw@gmail.com"> 回報錯誤</a>
            </span>
            <div className="x-divider mt:24 mb:24"></div>
            <div className="flex flex-direction:col gap:8 jc:center mt:8">
              <blockquote style={{ whiteSpace: "pre-line" }}>
                {this.state.error.stack}
              </blockquote>
              <blockquote>
                發生時間：{new Date().toLocaleDateString()}
                {new Date().toTimeString()}
              </blockquote>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
